{
  "sitemap": {
    "sitemap": "Mapa do site",
    "title": {
      "create": "Criar mapa do site",
      "edit": "Editar mapa do site"
    },
    "name": "Nome",
    "key": "Código chave (3 letras)",
    "colour_of_label": "Cor do rótulo",
    "versions": "Versões",
    "there_are_no_versions": "Não há versões neste mapa do site",
    "add_version": "Adicionar versão",
    "map_order": "Ordem do mapa"
  },
  "sitemapVersion": {
    "sitemapVersion": "Versão do mapa do site",
    "title": {
      "create": "Crie uma versão do mapa do site",
      "edit": "Editar uma versão do mapa do site"
    },
    "version": "Versão",
    "name": "Nome",
    "level_abbreviation": "Abreviatura de nível (máximo de 3 caracteres)",
    "level_index": "Índice",
    "tiles": "Telhas",
    "upload_tiles": "Carregar blocos",
    "remove_tiles": "Remover ladrilhos",
    "style": "Estilo",
    "upload_style": "Estilo de upload",
    "remove_style": "Remover estilo",
    "levels": "Níveis",
    "there_are_no_levels": "Não há níveis nesta versão",
    "add_level": "Adicionar nível",
    "uploading_tiles": "Enviando {{ level }}",
    "retry": "Tente novamente",
    "enter_level_name": "Insira o nome do nível",
    "level_index_must_be_unique": "O índice de nível deve ser exclusivo",
    "Pending": "Pendente",
    "Active": "Ativo",
    "Deleted": "Excluído",
    "Uploading": "Carregando",
    "Extracting": "Extraindo",
    "Reviewing": "Revisando",
    "Tiling": "Azulejos",
    "Failed": "Falhou",
    "deleteVersionWarning": "Um mapa do site deve ter pelo menos uma versão. Crie uma nova versão antes de excluir"
  },
  "sitemapVersionLevel": {
    "sitemapVersionLevel": "Nível de versão do mapa do site",
    "level": "Nível"
  },
  "levelsReassignmentDialog": {
    "title": "Reatribuição de nível",
    "paragraph1": "Você está prestes a remover alguns níveis, mas alguns objetos do mapa podem existir nesses níveis.",
    "paragraph2": "Para quais níveis você gostaria de movê-los?"
  },
  "cad": {
    "cadFile": "Arquivo CAD",
    "remove": "Arquivo DWG",
    "upload": "Carregar arquivo DWG",
    "coordinateSystem": "Sistema de coordenadas",
    "preset": {
      "title": "Predefinição de configuração",
      "placeholder": "Selecione entre os níveis de versão existentes do mapa do site"
    }
  },
  "sitemap_default": {
    "floor": "Piso térreo"
  }
}